import { SxProps } from "@mui/material";

export const sxTextLink: SxProps = {
  color: '#156d44',
  fontWeight: 600,
  textDecoration: 'underline',
}

export const sxSubTitle: SxProps = {
  color: '#383838',
  fontWeight: 600,
}